var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3212",
    "data-name": "Group 3212",
    transform: "translate(-879.217 -390)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_265",
    "data-name": "Ellipse 265",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(879.217 390)",
    fill: "#fdf5f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(895 406)",
    fill: "#fe6036"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3199",
    "data-name": "Group 3199",
    transform: "translate(-10075.356 -19037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15656",
    "data-name": "Path 15656",
    d: "M49.891,83.367a3.806,3.806,0,1,1-3.806-3.806,3.806,3.806,0,0,1,3.806,3.806Z",
    transform: "translate(10968.518 19422.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15657",
    "data-name": "Path 15657",
    d: "M49.831,10.06a5.691,5.691,0,0,0-1.146-2.936,4.978,4.978,0,0,0-8.076-.113,5.529,5.529,0,0,0-1.234,3.962L41.54,35.766a3.075,3.075,0,0,0,6.127,0l2.165-24.793A5.584,5.584,0,0,0,49.831,10.06Z",
    transform: "translate(10970 19460)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpps);
export default __webpack_public_path__ + "static/media/Opps.9a554e0f0f03a21df527fe0329d51d81.svg";
export { ForwardRef as ReactComponent };